import Aboutme from "../../Components/Aboutme";


export default function About() {
    return(
    <>
        <Aboutme/>
    </>
    )
 }